import axios from "axios";

export default {
  getAgent(agent, jwt) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.PARTNER_PRIVATE_PATH}/${agent}`,
        headers: {
          authorization: `Bearer ${jwt}`
        }
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
    });
  },

  getPartnerSettings(agent) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.PARTNER_SERVICE_PUBLIC_PATH}/partner/settings`,
        params: {agent: agent}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
    });
  }
};


// WEBPACK FOOTER //
// ./src/services/partnerService.js